import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useAuth } from '../../hooks/useAuth';
// import { industries, professions } from '../../constants/ProfileData';

const Settings = () => {
    const [showPasswordFields, setShowPasswordFields] = useState(false);
    const [oldPass, setOldPass] = useState('');
    const [newPass, setNewPass] = useState('');
    const [confirmPass, setConfirmPass] = useState('');
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [gender, setGender] = useState('');
    const [dob, setDob] = useState('');
    const [industry, setIndustry] = useState('');
    const [profession, setProfession] = useState('');
    const { user, getToken } = useAuth();

    const [userSettings, setUserSettings] = useState({});

    const fetchUserSettings = async () => {
        const token = getToken();
        if (token) {
            try {
                const response = await new WebApiCalls().getUserSettings(token);

                if (response?.code === 200) {
                    setUserSettings(response.data);
                } else {
                    toast.error(response?.desc || 'Failed to fetch user settings');
                }
            } catch (error) {
                console.error('Error fetching user settings:', error);
                toast.error('An error occurred while fetching user settings');
            }
        }
    };

    useEffect(() => {
        fetchUserSettings();
    }, []);

    useEffect(() => {
        if (userSettings) {
            setFullName(userSettings.name || '');
            setEmail(userSettings.email || '');
            setPhone(userSettings.phone_no || '');
            setGender(userSettings.gender || '');
            setDob(userSettings.dob || '');
            setIndustry(userSettings.industry || '');
            setProfession(userSettings.profession || '');
        }
    }, [userSettings]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (showPasswordFields) {
            if (!oldPass || !newPass || !confirmPass) {
                toast.error('All password fields are required.');
                return;
            }
            if (newPass !== confirmPass) {
                toast.error('Passwords do not match.');
                return;
            }
        }

        const token = getToken();
        if (token) {
            const obj = {
                userId: user?._id, // Ensure user ID is sent
                name: fullName,
                email,
                phone_no: phone,
                gender,
                dob,
                industry,
                profession,
                pass_type: showPasswordFields ? 'update' : undefined,
                current_password: showPasswordFields ? oldPass : undefined,
                new_password: showPasswordFields ? newPass : undefined
            };

            new WebApiCalls()
                .udpateSettings(token, obj)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Profile updated successfully.');
                        if (showPasswordFields) {
                            setOldPass('');
                            setNewPass('');
                            setConfirmPass('');
                            setShowPasswordFields(false); // Reset view after password update
                        }
                    } else {
                        toast.error(res?.desc || 'Oops...! Something went wrong.');
                    }
                })
                .catch((err) => console.error(err));
        }
    };

    return (
        <Container fluid>
            <Form onSubmit={handleSubmit}>
                <Row className="mx-auto w-50">
                    <Col>
                        {!showPasswordFields ? (
                            <>
                                <Form.Label>Full Name</Form.Label>
                                <Form.Control
                                    className="login-input shadow-none mb-3"
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                    type="text"
                                    placeholder="Full Name"
                                    required
                                />

                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    className="login-input shadow-none mb-3"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    placeholder="Email"
                                    required
                                />

                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    className="login-input shadow-none mb-3"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    type="text"
                                    placeholder="Phone Number"
                                    required
                                />

                                {/* <Form.Label>Gender</Form.Label>
                                <Form.Select className="login-input shadow-none mb-3" value={gender} onChange={(e) => setGender(e.target.value)} required>
                                    <option value="">Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="other">Other</option>
                                </Form.Select> */}

                                {user?.role !== 'agency' && (
                                    <>
                                        <Form.Label>Date of Birth</Form.Label>
                                        <Form.Control
                                            className="login-input shadow-none mb-3"
                                            value={dob}
                                            onChange={(e) => setDob(e.target.value)}
                                            type="date"
                                            required
                                        />
                                    </>
                                )}

                                {/* <Form.Label>Industry</Form.Label>
                                <Form.Select className="login-input shadow-none mb-3" value={industry} onChange={(e) => setIndustry(e.target.value)} required>
                                    <option value="">Select Industry</option>
                                    {industries.map((industry) => (
                                        <option value={industry.value}>{industry.label}</option>
                                    ))}
                                </Form.Select>

                                <Form.Label>Profession</Form.Label>
                                <Form.Select className="login-input shadow-none mb-3" value={profession} onChange={(e) => setProfession(e.target.value)} required>
                                    <option value="">Select Profession</option>
                                    {professions.map((profession) => (
                                        <option value={profession.value}>{profession.label}</option>
                                    ))}
                                </Form.Select> */}
                            </>
                        ) : (
                            <>
                                <Form.Label>Old Password</Form.Label>
                                <Form.Control
                                    className="login-input shadow-none mb-3"
                                    value={oldPass}
                                    onChange={(e) => setOldPass(e.target.value)}
                                    type="password"
                                    placeholder="Old password"
                                    required
                                />

                                <Form.Label>New Password</Form.Label>
                                <Form.Control
                                    className="login-input shadow-none mb-3"
                                    value={newPass}
                                    onChange={(e) => setNewPass(e.target.value)}
                                    type="password"
                                    placeholder="New password"
                                    required
                                />

                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control
                                    className="login-input shadow-none mb-3"
                                    value={confirmPass}
                                    onChange={(e) => setConfirmPass(e.target.value)}
                                    type="password"
                                    placeholder="Confirm password"
                                    required
                                />
                            </>
                        )}
                    </Col>
                    <Row className="p-0 mt-3">
                        <Col className="d-flex justify-content-end p-0">
                            <Button type="submit" bsPrefix="submit-btn" size="md">
                                {showPasswordFields ? 'Change Password' : 'Save'}
                            </Button>
                        </Col>
                    </Row>
                    <Row className="p-0 mt-3">
                        <Col className="d-flex justify-content-center p-0">
                            <Button variant="link" onClick={() => setShowPasswordFields(!showPasswordFields)}>
                                {showPasswordFields ? 'Back to Profile' : 'Change Password'}
                            </Button>
                        </Col>
                    </Row>
                </Row>
            </Form>
        </Container>
    );
};

export default Settings;
